<template>
    <transition
        enter-class="opacity-0"
        enter-active-class="transition-opacity duration-200"
        leave-to-class="opacity-0"
        leave-active-class="transition-opacity duration-200"
    >
        <Layout :show-background="true" v-show="ready"
                container-class="flex flex-col justify-center min-h-screen py-10 sm:min-h-0 bg-primary">
            <div v-if="ready" class="w-full max-w-sm px-10 mx-auto">
                <div class="flex justify-center mb-8">
                    <img :src="config.service_logo" :alt="config.service_name"
                         class="block w-auto h-12">
                </div>
                <h1 class="mb-2 text-lg font-semibold leading-tight text-center text-highlight-100">
                    {{ _('account_title') }}
                </h1>

                <p class="mb-8 text-sm font-medium text-center text-highlight-60">{{
                    _('account_member_since') }} {{ formatDate(user.created_at) }}</p>

                <div class="mb-6" v-if="user.name">
                    <h3 class="mb-2 text-sm font-semibold text-highlight-100">{{
                        _('account_label_name') }}</h3>
                    <p class="text-highlight-100">{{ user.name }}</p>
                </div>

                <div class="mb-8">
                    <h3 class="mb-2 text-sm font-semibold text-highlight-100">{{
                        _('account_label_email') }}</h3>
                    <p class="text-highlight-100">{{ user.email }}</p>
                </div>

                <p class="text-sm text-center text-highlight-100">{{ _('account_edit') }}</p>

                <hr class="my-6 border-highlight-20">

                <template v-if="providerSubscriptions.length > 0">
                    <h2 class="my-2 font-semibold leading-tight text-md text-highlight-100">
                        {{ _('account_plan_title') }}
                    </h2>

                    <div
                        v-for="(subscription, index) in providerSubscriptions"
                        class="p-4 mb-6 border border-solid border-highlight-20 bg-highlight-10"
                        :key="index"
                    >
                        <p class="mb-2 font-medium capitalize">{{ subscription.provider }}</p>

                        <a
                            href="#"
                            @click="cancelSubscription(subscription.telco.subscriptionId, subscription.telco.msisdn)"
                            class="underline text-accent"
                        >
                            {{ _('account_unsubscribe') }}
                        </a>
                    </div>
                </template>
            </div>
        </Layout>
    </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import NProgress from 'nprogress'
import Layout from '@/components/Layout.vue'

export default {
    components: {
        Layout,
    },
    data() {
        return {
            ready: false,
            config: '',
        }
    },
    computed: {
        ...mapGetters({
            fetched: 'localisation/fetched',
            _: 'localisation/translate',
            params: 'settings/get',
            client: 'settings/getClient',
            authenticated: 'user/authenticated',
            provider: 'providers/selected',
            user: 'user/get',
            subscriptions: 'user/subscriptions',
        }),
        providerSubscriptions() {
            return this.subscriptions.filter(
                (subscription) => subscription.provider === this.provider.name.toLowerCase(),
            )
        },
    },
    watch: {
        fetched: {
            immediate: true,
            deep: true,
            handler(fetched) {
                if (fetched) {
                    setTimeout(() => {
                        this.ready = true
                        NProgress.done()
                    }, 1000)
                }
            },
        },
        authenticated: {
            immediate: true,
            deep: true,
            handler(authenticated) {
                if (typeof authenticated.access_token === 'undefined') {
                    this.$router.push({ name: 'Login' })
                }
            },
        },
    },
    created() {
        NProgress.start()
    },
    async mounted() {
        if (Object.keys(this.authenticated).length) {
            const { access_token } = this.authenticated
            this.$store.dispatch('user/get', access_token)
                .then(() => this.$store.dispatch('user/subscriptions', {
                    key: this.params.api_key,
                    userId: this.user.id,
                }))
        } else if (Object.keys(this.$route.query).includes('access_token')) {
            this.$store.dispatch('user/get', this.$route.query.access_token)
                .then(() => this.$store.dispatch('user/subscriptions', {
                    key: this.params.api_key,
                    userId: this.user.id,
                }))
        } else {
            this.$router.push({ name: 'Login' })
        }

        this.config = await import(`@/resources/${this.client}`)
    },
    methods: {
        async cancelSubscription(subscriptionId, msisdn) {
            await this.$store.dispatch('charge/cancel', {
                vendor: this.provider.name.toLowerCase(),
                msisdn,
                subscriptionId,
            })
        },
        formatDate(datetime) {
            return (new Date(datetime)).toDateString()
        },
    },
}
</script>
